import { Modelo } from '@ext/index';
import * as Types from './Situacion.types';
import moment, { Moment } from 'moment';
import { Empresa } from '@/__env/lib/MercadoLibre/Cuentas/Cuentas';

export class ISituacion extends Modelo {

    public constructor( Json: any = null ) {
        super( Json );
        if ( Json )
            this.set();
    }

    public Mes: number = moment().getMonth();
    public Ano: number = moment().getYear();
    public Empresa: Empresa = null;
    public Gasto: number = 0;
    public Ventas: number = 0;
    public Costos: number = 0;

    public get Renta(): number {
        return this.Ventas - this.Costos;
    }

    public get Porcentaje(): number {
        if ( this.Gasto > 0 )
            return ( this.Renta / this.Gasto ) * 100;
        else
            return ( this.Renta / this.GastoEstimado ) * 100;
    }

    public get GastoEstimado(): number
    {
        let g = this.Empresa.esCASAJARSE ? 8110655 : 3399679;

        let modificador = 0;
        if ( this.Fecha.getYear() == 2020 && this.Fecha.getMonth() == 6 ) modificador = .05;
        else if ( this.Fecha.getYear() == 2020 && this.Fecha.getMonth() == 7 ) modificador = .10;
        else if ( this.Fecha.getYear() == 2020 && this.Fecha.getMonth() == 8 ) modificador = .15;
        else if ( this.Fecha.getYear() == 2020 && this.Fecha.getMonth() == 9 ) modificador = .19;
        else if ( this.Fecha.getYear() == 2020 && this.Fecha.getMonth() == 10 ) modificador = .24;
        else if ( this.Fecha.getYear() == 2020 && this.Fecha.getMonth() == 11 ) modificador = .30;
        else if ( this.Fecha.getYear() == 2020 && this.Fecha.getMonth() == 12 ) modificador = .35;
        else if ( this.Fecha.getYear() == 2021 && this.Fecha.getMonth() == 1 ) modificador = .40;
        else if ( this.Fecha.getYear() == 2021 && this.Fecha.getMonth() == 2 ) modificador = .45;
        else if ( this.Fecha.getYear() == 2021 && this.Fecha.getMonth() == 3 ) modificador = .50;
        else if ( this.Fecha.getYear() == 2021 && this.Fecha.getMonth() == 4 ) modificador = .55;
        else if ( this.Fecha.getYear() == 2021 && this.Fecha.getMonth() == 5 ) modificador = .60;
        else if ( this.Fecha.getYear() == 2021 && this.Fecha.getMonth() == 6 ) modificador = .65;
        else if ( this.Fecha.getYear() == 2021 && this.Fecha.getMonth() == 7 ) modificador = .70;
        else if ( this.Fecha.getYear() == 2021 && this.Fecha.getMonth() == 8 ) modificador = .75;

        return g * ( 1 + modificador );
    }

    public get Fecha(): Moment {
        let e = moment();
        e.set( "month", this.Mes - 1 );
        e.set( "year", this.Ano );
        return e;
    }

    public set(): boolean {

        this.Mes = !this.Json.mes ? 0 : this.Json.mes;
        this.Ano = !this.Json.ano ? 0 : this.Json.ano;
        this.Empresa = Empresa.toTipo(this.Json.empresa);
        this.Gasto = !this.Json.gasto ? 0 : this.Json.gasto;
        this.Ventas = !this.Json.ventas ? 0 : this.Json.ventas;
        this.Costos = !this.Json.costos ? 0 : this.Json.costos;


        this.Existe = true;
        return this.Existe;
    }

    public get Vista(): Vista {
        return new Vista( this );
    }
}

class Vista {
    constructor( Model: ISituacion ) {
        this.Model = Model;
    }

    public Model: ISituacion;
}


